import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useProjects } from "../hooks/usePm";
import { useAdminScope } from "../lib/auth/useGrantedScope";
import { chipMeta, PROJECT_STATUS_META } from "../lib/statusMeta";
import { codeLabel } from "../lib/format";
import { ScreenHeader } from "../components/ScreenHeader";
import { ProjectFormSheet } from "../components/ProjectFormSheet";

export function ProjectsScreen() {
  const { data, isLoading, isError } = useProjects();
  const navigate = useNavigate();
  const canCreate = useAdminScope("pm:project:create");
  const [creating, setCreating] = useState(false);

  const projects = data?.items ?? [];

  return (
    <div className="screen projects-screen">
      <ScreenHeader
        title="Projets"
        aside={
          canCreate && (
            <button
              type="button"
              className="pill-btn"
              onClick={() => setCreating(true)}
            >
              Nouveau projet
            </button>
          )
        }
      />

      {isLoading && <div className="empty-state">Chargement…</div>}
      {isError && (
        <div className="empty-state">Impossible de charger les projets.</div>
      )}
      {!isLoading && !isError && projects.length === 0 && (
        <div className="empty-state">Aucun projet visible.</div>
      )}

      <div className="card-list">
        {projects.map((p) => {
          const meta = chipMeta(PROJECT_STATUS_META, p.status);
          return (
            <button
              key={p.id}
              className="task-card"
              onClick={() => navigate(`/projets/${p.id}`)}
            >
              <div className="ttl">{codeLabel(p.code, p.name)}</div>
              <div className="row-line">
                <span
                  className="chip"
                  style={{ background: meta.bg, color: meta.color }}
                >
                  {meta.label}
                </span>
                <div className="progress-track">
                  <div
                    className="fill"
                    style={{ width: `${p.progress_pct}%` }}
                  />
                </div>
                <span className="due">{p.progress_pct}%</span>
              </div>
            </button>
          );
        })}
      </div>

      {creating && (
        <ProjectFormSheet
          onClose={() => setCreating(false)}
          onSaved={(p) => {
            setCreating(false);
            navigate(`/projets/${p.id}`);
          }}
        />
      )}
    </div>
  );
}

export default ProjectsScreen;
